<div dialog-header>
  <h4>Unsuccessful Contracts</h4>
  <button class="close-btn" (click)="close()">
    <app-icon name="cross" width="16px" height="16px" />
  </button>
</div>

<app-icon name="circle_warning" width="75px" height="75px" />

<div class="errors-block">
  <div>
    <p>Contract</p>
    <p>Error Message</p>
  </div>
  @for (item of invalidCart; track item) {
    <div>
      <p>{{ item.product.productCategory }} - {{ item.product.planName.enUsPlanName }}</p>
      <p>{{ item.message }}</p>
    </div>
  }
</div>

<div dialog-actions>
  <button ui-button type="secondary" (click)="close()">Continue</button>
</div>
